import { CALL_API } from "../../api";
import * as ActionTypes from "./campaign.actionTypes";
import schema from "../../api/schema";

const readCampaigns = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_CAMPAIGNS_REQUEST,
      ActionTypes.READ_CAMPAIGNS_SUCCESS,
      ActionTypes.READ_CAMPAIGNS_FAILURE
    ],
    endpoint: "api/campaign/",
    schema: schema.campaignsSchema,
    authorization: true
  }
});

export const getCampaigns = () => (dispatch, getState) => {
  return dispatch(readCampaigns());
};

const readCampaign = id => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_CAMPAIGN_REQUEST,
      ActionTypes.READ_CAMPAIGN_SUCCESS,
      ActionTypes.READ_CAMPAIGN_FAILURE
    ],
    endpoint: `api/campaign/${id}`,
    schema: schema.campaignSchema,
    authorization: true
  },
  payload: {
    id
  }
});

export const getCampaign = id => (dispatch, getState) => {
  const campaign = getState().entities.campaign.byId[id];
  if (campaign) {
    return Promise.resolve();
  }
  return dispatch(readCampaign(id));
};

const readCurrentCampaign = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_CURRENT_CAMPAIGN_REQUEST,
      ActionTypes.READ_CURRENT_CAMPAIGN_SUCCESS,
      ActionTypes.READ_CURRENT_CAMPAIGN_FAILURE
    ],
    endpoint: `api/campaign/current`,
    schema: schema.campaignSchema,
    authorization: true
  }
});

export const getCurrentCampaign = () => (dispatch, getState) => {
  const campaign = getState().entities.campaign.current;
  if (campaign) {
    return Promise.resolve();
  }
  return dispatch(readCurrentCampaign());
};

const doCreateCampaign = data => ({
  [CALL_API]: {
    types: [
      ActionTypes.CREATE_CAMPAIGN_REQUEST,
      ActionTypes.CREATE_CAMPAIGN_SUCCESS,
      ActionTypes.CREATE_CAMPAIGN_FAILURE
    ],
    endpoint: "api/campaign/",
    schema: schema.campaignSchema,
    authorization: true,
    requestInit: {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(data)
    }
  }
});

export const createCampaign = data => (dispatch, getState) => {
  return dispatch(doCreateCampaign(data));
};

const doUpdateCampaign = data => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPDATE_CAMPAIGN_REQUEST,
      ActionTypes.UPDATE_CAMPAIGN_SUCCESS,
      ActionTypes.UPDATE_CAMPAIGN_FAILURE
    ],
    endpoint: `api/campaign/${data._id}`,
    schema: schema.campaignSchema,
    authorization: true,
    requestInit: {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(data)
    }
  },
  payload: {
    id: data._id
  }
});

export const updateCampaign = data => (dispatch, getState) => {
  return dispatch(doUpdateCampaign(data));
};

const doDeleteCampaign = id => ({
  [CALL_API]: {
    types: [
      ActionTypes.DELETE_CAMPAIGN_REQUEST,
      ActionTypes.DELETE_CAMPAIGN_SUCCESS,
      ActionTypes.DELETE_CAMPAIGN_FAILURE
    ],
    endpoint: `api/campaign/${id}`,
    schema: schema.campaignSchema,
    authorization: true,
    requestInit: {
      method: "DELETE"
    }
  },
  payload: {
    id
  }
});

export const deleteCampaign = id => (dispatch, getState) => {
  return dispatch(doDeleteCampaign(id));
};



// WEBPACK FOOTER //
// ./src/modules/campaign/campaign.actions.js